import { combineReducers } from 'redux';

import initializeSlice from 'store/initialize';
import applicationSlice from 'store/application';
import overviewSlice from 'store/overview';
import resetSlice from 'store/reset';
import userSlice from 'store/user';
import pkdApi from 'store/api/pkd';
import auth0Api from 'store/api/auth0';

const rootReducer = combineReducers({
  [initializeSlice.name]  : initializeSlice.reducer,
  [applicationSlice.name] : applicationSlice.reducer,
  [overviewSlice.name]    : overviewSlice.reducer,
  [resetSlice.name]       : resetSlice.reducer,
  [userSlice.name]        : userSlice.reducer,
  [pkdApi.reducerPath]    : pkdApi.reducer,
  [auth0Api.reducerPath]  : auth0Api.reducer,
});

export default rootReducer;
